import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { listar_obj } from '../../actions'

const mapStateToProps = (state, props) => {


    const { componentes, customFormUid, titulo, global } = props
    const { DinamicCustomFormsReducer } = state
    const controler = DinamicCustomFormsReducer.rLista;

    let listaForms = controler.lista;
    let customForm = null;
    listaForms.forEach(f => {
        if (f.uid === customFormUid) {
            customForm = f;
        }
    });


    let loading = true;
    let lista = null;
    let chaveReducer = customFormUid;

    if (customForm.chaveSalvar) {
        chaveReducer = customForm.chaveSalvar
    }

    if (DinamicCustomFormsReducer.rListaObj[chaveReducer]) {
        loading = DinamicCustomFormsReducer.rListaObj[chaveReducer].loading;
        lista = DinamicCustomFormsReducer.rListaObj[chaveReducer].lista;
    }

    let listaFinal = [];
    if (lista) {
        listaFinal = lista.slice()
    }
    let colunas = []
    let compUsar = componentes;
    if (!compUsar) {

        compUsar = customForm.componenteRoot.componentes
    }
    criaColunas(compUsar, colunas)
    return {
        form: 'CustonFormPesquisaForm' + customForm.nomeForm,
        customForm,
        loading, listaPesquisa: listaFinal, titulo: titulo, colunas, global,
        componentes: compUsar
    };
};


export default compose(
    connect(mapStateToProps, { listar: listar_obj }),
    reduxForm(),


);

function criaColunas(components, colunas) {


    components.forEach(comp => {
        let c = null
        if (comp.colunaPesquisa) {
            c = {
                id: comp.field, label: comp.label, getValue: item => {
                    let r = item[comp.field]
                    if (typeof r == typeof true) {
                        if (r) {

                            return "Sim"
                        } else {

                            return "Não"
                        }
                    }


                    return r
                }
            }

        }
        if (comp.filtroPesquisa) {
            c = { id: comp.field, label: comp.label, getValue: item => item[comp.field], filtro: true }
        }

        if (c) {
            colunas.push(c)
        }

        if (comp.componentes) {
            criaColunas(comp.componentes, colunas)
        }
    });
    if (!colunas.length) {
        colunas.push({ id: "UID", label: "UID", getValue: item => item.uid })
    }
    return colunas;

}


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/components/DinamicCrudCustomPesquisa/DinamicCrudCustomPesquisa.enhancer.js